// .bgdownを通り過ぎたら.zheaderにactiveを付与する
window.addEventListener('scroll', function() {
  const window_height = window.innerHeight;
  //var bgdown = document.querySelector('.bgdown');
  var bgdown = document.querySelector('.zcol-content');
  var zheader = document.querySelector('.zheader');

  //if (bgdown.getBoundingClientRect().top < 0) {
  if (bgdown.getBoundingClientRect().top < window_height*0.75) {
      zheader.classList.add('active');
      zheader.classList.add('change-active');
  } else {
      zheader.classList.remove('active');
      zheader.classList.remove('change-active');
  }
});



// おすすめの商品スライド
const circlePaginationSlider = new Swiper('.circlePaginationSlider', {
    loop: true,
    speed: 500,
    effect: 'fade',
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    fadeEffect: {//ここにオプションを指定します。
    crossFade: true
    },
    pagination: {
        el: '.swiper-pagination-rec',
        clickable: true,
        renderBullet: function (index, className) {
            let num = index + 1;
            return (
                '<div class="' + className + ' circle-pagination' + '"><div class="circle-pagination__inner lato-regular"><svg width="30" height="30"><circle cx="15" cy="15" r="14.5"></circle></svg>' + num + '</div></div>'
            )
        },
    },
    navigation: {
    nextEl: ".swiper-button-next-rec",
    prevEl: ".swiper-button-prev-rec",
    },
    on: {
        slideChange: function () {
            if (this.realIndex > 0) {
                this.params.autoplay.delay = 4500;
            }
        },
    },
});

// ブランド一覧スライド
const swiper = new Swiper('.brand-swiper', {
  // Optional parameters
  slidesPerView: 1,
  spaceBetween: 10,

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next-brand',
    prevEl: '.swiper-button-prev-brand',
  },

  breakpoints: {
    // when window width is >= 480px
    480: {
      slidesPerView: 2,
      spaceBetween: 10
    },
    // when window width is >= 768px
    768: {
      slidesPerView: 3,
      spaceBetween: 15
    },
    // when window width is >= 1024px
    1024: {
      slidesPerView: 4,
      spaceBetween: 20
    }
  }
});




document.addEventListener("DOMContentLoaded", function(){

    //JSで再配置
    if (document.getElementById('FROM-index-main') != null) {
          const toIndexMain = document.getElementById('TO-index-main');
          const fromIndexMain = document.getElementById('FROM-index-main');
          toIndexMain.appendChild(fromIndexMain);
    }

  
      // メインスライド
    const mySwiper = new Swiper('.swiper', {
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      speed: 1300,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        waitForTransition: false,
      },
      followFinger: false,
      pagination: {
        el: '.swiper-pagination' ,
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });


});
